import { useOptionalUniversalEntityPageStaticContext } from "../UniversalEntityPage/contexts/UniversalEntityPageStaticContext";
import type { AuthenticatedUser } from "@/lib/types/unified";
import type React from "react";

export type GroupingViewMode = "table" | "grouped" | "cards" | "board";

export interface GroupingPageContextValues {
  viewMode: GroupingViewMode;
  appUser: AuthenticatedUser | undefined;
  BoardViewComponent: React.ComponentType | undefined;
}

const DEFAULT_CONTEXT: GroupingPageContextValues = {
  viewMode: "table",
  appUser: undefined,
  BoardViewComponent: undefined,
};

/**
 * Reads the optional UniversalEntityPage STATIC context without throwing when
 * absent (GroupingWrapper also renders outside an entity page).
 *
 * Deliberately the static slice only: everything this returns — view mode, the
 * signed-in user, the board component — is page-shell state. Reading it off the
 * god context meant every keystroke in the search box re-rendered the grouping
 * wrapper and, through it, the whole table.
 */
export function useGroupingPageContext(): GroupingPageContextValues {
  const context = useOptionalUniversalEntityPageStaticContext();
  if (!context) {
    return DEFAULT_CONTEXT;
  }
  return {
    viewMode: context.viewModeState.viewMode,
    appUser: context.auth.appUser,
    BoardViewComponent: context.pageConfig.customComponents?.boardView,
  };
}
